interface AuthPoolQuiz {
    poolId: string;
    quizzes: QuizAttempt[];
}

interface QuizAttempt {
    quizId: string;
    numberOfAttempts: number;
    lastAttempt: Pick<QuizTracker, "id" | "start_time" | "end_time" | "isSuccessful" | "score" | "last_answered_question_id">;
}

interface GetAuthUserPoolQuizResponse {
    getAuthUserPoolQuiz: AuthPoolQuiz[];
}

interface GetPoolQuizzesResponse {
    getPoolQuizzes: Quiz[];
}

interface GetPoolQuizQuestionResponse {
    getPoolQuizQuestion: QuestionDetail;
}

interface SubmitAnswerResponse {
    id: string;
    points: number;
    isCorrect: boolean;
    isLastQuestion: boolean;
    answerId: string;
    nextQuestion: QuestionDetail;
    quizTracker: QuizTracker;
}

interface AnswerQuizQuestionResponse {
    answerQuizQuestion: SubmitAnswerResponse;
}

interface Question {
    id: string;
    orderNumber: number;
}

interface QuestionDetail extends Question {
    question: string;
    answers: Answer[];
}

interface Answer {
    id: string;
    orderNumber: number;
    answer: string;
}

interface Quiz {
    id: string;
    title: string;
    description: string;
    image: string;
    question: Question[];
    timeLimitInSeconds: number;
    orderNumber: number;
    lessonType: string; // Define enum here
    lessonContent: string;
    poolId: string;
}

interface QuizTracker {
    id: string;
    pool_id: string;
    quiz_id: string;
    user_id: string;
    start_time: Date;
    end_time: Date;
    createdAt: Date;
    updatedAt: Date;
    isSuccessful: boolean;
    score: number;
    last_answered_question_id: string;
}

type AnswerResponse = Pick<SubmitAnswerResponse, "id" | "points" | "isCorrect">

interface Submission {
    poolId: string;
    quizId: string;
    questionId: string;
    answerId: string;
    isLastQuestion: boolean;
    answerResponse: AnswerResponse;
}

type SubmissionSummary = Pick<Submission, "questionId" | "answerId" | "answerResponse">

interface QuizSubmissionsResponse {
    poolId: string;
    quizId: string;
    submissions: SubmissionSummary[];
}

interface QuizResultResponse {
    getQuizResultsBySubmissionId: QuizResult
}

interface QuizResult {
    id: string;
    poolId: string;
    quizId: string;
    questionResults: QuestionResult[];
}

interface UserAnswer {
    id: string;
    questionId: string;
    points: number;
    isCorrect: boolean;
    isLastQuestion: boolean;
    nextQuestion: QuestionDetail;
    quizTracker: QuizTracker;
}

interface QuestionResult {
    question: QuestionDetail;
    userAnswer: UserAnswer;
}

export enum QuizStatuses {
    ON_GOING = "ON_GOING",
    EXPIRED = "EXPIRED",
    FAILED = "FAILED",
    PASSED = "PASSED",
  }

type StartQuizType = 'start' | 'restart' | 'resume'

interface GetPoolQuizQuestionArgs {
    startQuizType: StartQuizType;
    poolId?: string;
    quizId?: string;
    questionId?: string;
}

interface LearnContextProps {
    activeQuizzes: any;
    quizTracker: any,
    nextQuestion: any,
    activeQuizSubmissions: any,
    currentQuizQuestionsWithDetails: any,
    quizzes?: Quiz[]; 
    quizIndex: number;
    quizStartTime?: number;
    quizStatus?: QuizStatuses;
    getPoolQuizzes: (poolId: string) => void;
    getAuthUserPoolQuiz: VoidFunction,
    getPoolQuizQuestion: (options: GetPoolQuizQuestionArgs)=> void,
    answerQuizQuestion: (poolId: string, quizId: string, questionId: string, answerId: string) => void;
    getQuizResultsBySubmissionId: (submissionId: string) => void;
    updateQuizIndex: VoidFunction;
    setQuizIndex: (quizIndex: number) => void;
    resetLearnState: VoidFunction;
    resetQuizState: VoidFunction;
    clearPreviousAttempt: VoidFunction;
    setQuizAttempt: (quizAttempt: QuizAttempt) => void;
    hasFailed: (poolId: string) => boolean;
}

interface LearnStateInterface {
    activeQuizzes: AuthPoolQuiz[] | null;
    quizTracker: any,
    nextQuestion: any,
    activeQuizSubmissions: any,
    currentQuizQuestionsWithDetails: any,
    quizzes?: any[];
    quizIndex: number;
    quizStartTime?: any;
    isFetching: boolean;
    error: any;
    questionIndex: number;
    quizStatus: QuizStatuses | undefined;
    liveQuiz?: any;
}

  
export type {
    AuthPoolQuiz,
    QuizAttempt,
    GetAuthUserPoolQuizResponse,
    GetPoolQuizzesResponse,
    GetPoolQuizQuestionResponse,
    AnswerQuizQuestionResponse,
    Question,
    QuestionDetail,
    Answer,
    Quiz,
    QuizTracker,
    AnswerResponse,
    Submission,
    SubmissionSummary,
    QuizSubmissionsResponse,
    QuizResult,
    QuizResultResponse,
    QuestionResult,
    LearnContextProps,
    StartQuizType,
    GetPoolQuizQuestionArgs,
    LearnStateInterface,
}